export const initialStateModal = {
    isOpen: false,
    type: "",
    title: "",
    message: ""
}